import ReactModal from 'react-modal';
import SVG from 'react-inlinesvg';
import cx from 'classnames';
import close from 'assets/icons/close.svg';
import Button, { Color } from 'lib/Button';
import { ModalProps } from './Modal.types';

const Modal = ({
  isOpen,
  onClose,
  title,
  text,
  icon,
  children,
  actionButtons,
  dataTestId,
  shouldCloseOnOverlayClick = true,
  shouldCloseOnEsc = true,
  customHeaderComponent,
  iconStyles,
  sidebar,
  size,
  customChildrenClasses,
  customContentClasses,
  customHeaderClasses,
}: ModalProps): React.ReactElement => {
  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
      onRequestClose={onClose}
      overlayClassName="bg-modalOverlay-dark fixed inset-x-0 inset-y-0 z-50"
      className={`bg-neutral-50 absolute transform -translate-y-2/4 -translate-x-2/4 top-1/2 left-1/2 rounded-md ${size}`}
    >
      <div className={cx('flex max-h-popup flex-row gap-4 p-6', customContentClasses)} data-test-id={dataTestId}>
        <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-4">
          <div className={cx('flex items-center gap-3', customHeaderClasses)}>
            {icon && (
              <div className="shrink-0" data-test-id="modal-icon">
                <SVG src={icon} className={cx('h-6 w-6 p-0.5 text-neutral-500', iconStyles)} />
              </div>
            )}
            <div className="grow sub-header-lg">{title}</div>
            {customHeaderComponent && <div>{customHeaderComponent}</div>}
            {onClose && (
              <Button
                dataTestId="close-modal-button"
                onClick={onClose}
                svg={close}
                svgClassnames="w-6 h-6 text-neutral-950-opacity-70"
                color={Color.TRANSPARENT}
                classNames="!p-0"
              />
            )}
          </div>
          {text && <div className="body-lg text-essential-secondary">{text}</div>}
          {children && (
            <div
              className={cx('max-h-popupContent min-h-0 flex-1 overflow-auto leading-normal', customChildrenClasses)}
            >
              {children}
            </div>
          )}
          {actionButtons && <div className="flex justify-end space-x-3 pt-3">{actionButtons}</div>}
        </div>
        {sidebar ? (
          <div className="w-9/20 min-h-0 overflow-auto border-l border-neutral-100-opacity-10">{sidebar}</div>
        ) : null}
      </div>
    </ReactModal>
  );
};

export default Modal;
